// extracted by mini-css-extract-plugin
module.exports = {"copy-ctn":"CopyText_copy-ctn__9_Fce","copyCtn":"CopyText_copy-ctn__9_Fce"};